import { HTTP_AP_ListCases_ForClientDetail_Request_Filter, HTTP_AP_ListCases_ForClientDetail_Request_Sort } from '@api-new/caseservice';
import { ClientCasesTableRowModel } from '@platform/client/models/client-cases-table-row.model';
import { RowDefinitionTypeEnum } from '@shared/components/table/enums/row-definition-type.enum';
import { TableRowDefinitionModel } from '@shared/components/table/models/table-row-definition.model';

export const clientCasesTableFilterDefaults: HTTP_AP_ListCases_ForClientDetail_Request_Filter = {
  caseStatus: null,
  caseType: null,
};

export const clientCasesTableRowDefinition = (): TableRowDefinitionModel<
  ClientCasesTableRowModel,
  HTTP_AP_ListCases_ForClientDetail_Request_Sort
>[] => [
  {
    columnLabel: 'Case type',
    columnKey: 'caseTypeMapped',
    type: RowDefinitionTypeEnum.Text,
    width: {
      min: '125px',
      max: '125px',
    },
  },
  {
    columnLabel: 'Created',
    columnKey: 'createdAt',
    type: RowDefinitionTypeEnum.DateTimeSince,
    sortKey: 'byCreatedAt',
    width: {
      min: '140px',
      max: '140px',
    },
  },
  {
    columnLabel: 'Case status',
    columnKey: 'mortgageCaseStatusMapped',
    type: RowDefinitionTypeEnum.Text,
    width: {
      min: '140px',
      max: '140px',
    },
  },
  {
    columnLabel: 'Address',
    columnKey: 'address',
    type: RowDefinitionTypeEnum.Text,
    width: {
      min: '140px',
      max: '140px',
    },
  },
  {
    columnLabel: 'New loan amount',
    columnKey: 'loanAmount',
    type: RowDefinitionTypeEnum.Currency,
    sortKey: 'byLoanAmount',
    width: {
      min: '140px',
      max: '140px',
    },
  },
];
